// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__OYzXb","shadow":"Image_shadow__3_hgu","circle":"Image_circle__1SvPQ"};